<template>
    <v-data-table
        dense
        :headers="headers"
        :loading="loading"
        :items="messages">
    </v-data-table>
</template>

<script>
export default {
    name: "CustomerSentSmsDatatable",
    props: {
        loading: {
            type: Boolean,
            required: true
        },
        messages: {
            type: Array,
            requried: true
        }
    },
    data() {
        return {
            headers: [
                {text: "Phone", value: "phone"},
                {text: "Messages", value: "message", width: "70%"},
                {text: "Date/Time", value: "sent_at"}
            ]
        }
    }
}
</script>